/**
 * Data loaders — wired into `config.loaders`.
 */

import { loadSummaryTables, loadSystemLayers } from '#lib/common/loaders.js';
import { EAbleyLinksModule, EProduct, type ILinksSummaryData } from './interfaces';
import { LINKS_DATASET, buildSystemLayers } from './layers';

export const loadSystem = (apiKey: string) =>
	loadSystemLayers(apiKey, [LINKS_DATASET], buildSystemLayers);

// Expects location + core.
export const loadSummary = async (apiKey: string): Promise<ILinksSummaryData> =>
	(await loadSummaryTables(
		apiKey,
		EProduct.AbleyLinks,
		LINKS_DATASET,
		[EAbleyLinksModule.core],
		1
	)) as unknown as ILinksSummaryData;
